<template>
	<div>
	    <van-nav-bar title="线索详情" left-text="返回" left-arrow @click-left="onClickLeft" :z-index=999 fixed>
		<div slot="right">
			<span v-if="checkPermission('分配线索')" style="margin-right:20px;color:#1890ff;" @click="selectUser(threadId,$event)">分配</span>
			<span v-if="type == 1 && userId === advisorId" style="color:#1890ff;" @click="transfer">转化</span>
		</div>
		</van-nav-bar>
	    <div class="form-box">
	        <table-grid meta-id="4" :data-id="threadId" :grouping="grouping">
			</table-grid>
	    </div>
		<select-staff :callback="assign" v-model="show"></select-staff>
	</div>
</template>

<script>
	import {NavBar,Button,Toast,Icon,Dialog} from 'vant';
	import selectStaff from "../components/SelectStaff";
	import threadService from "../service/threadService";
	import userInfo from '../store/userInfo';
	export default {
		data() {
			return {
				threadId: '',
				clue: {},
				advisorId: '',
				type: '',
				grouping: false,
				show: false,
			};
		},
		components: {
			selectStaff,
		    [NavBar.name]: NavBar,
			[Button.name]: Button,
			[Icon.name]: Icon,
			[Dialog.name]: Dialog,
		},
		computed: {
			userId() {
				return this.$store.getters.getUserId;
			},
		},
		mounted: async function() {
			if(this.$route.query.uuid) {
				this.threadId = this.$route.query.uuid;
			}else {
				this.threadId = this.$route.query.clueId;
			}
			this.type = this.$route.query.type;
			let resp = await threadService.getClueById(this.threadId);
			if(resp.data.Status === "1") {
				this.clue = resp.data.Data;
				this.advisorId = resp.data.Data.advisorId;
			}
			
		},
		methods:{
			selectUser(id,e) {
				e.stopPropagation();
				this.show = true;
			},
			async assign(staffId) {
				let staffIds = localStorage.getItem("staffIds");
				if (staffIds === undefined || staffIds === null) {
				    localStorage.setItem("staffIds", staffId);
				} else {
				    if (staffIds.split(staffId).length === 1) {
				        staffIds = staffIds + "," + staffId;
				        localStorage.setItem("staffIds", staffIds);
				    }
				}
				let resp = await threadService.distribution(staffId,this.threadId);
				if (resp.data.Status === "1") {
				   Toast.success('分配成功');
				}else {
					Toast.fail(resp.data.Data);
				}
			    
			},
			async transfer() {
				let clue = this.clue;
				if(clue.status === '1') {
					Toast.fail('选择中包含未分配的线索');
					return;
				}
				if(clue.status === '4') {
					Toast.fail('选择中包含已成交的线索');
					return;
				}
				if(clue.status === '6') {
					Toast.fail('选择中包含已转化为商机的线索');
					return;
				}
// 				let resp = await threadService.transfer(clue.uuid);
// 				if (resp.data.Status === "1") {
// 				   Toast.success('转化成功');
// 				   let that = this;
// 				   setTimeout(function(){
// 					   that.$router.push({path:"Thread"})
// 				   },2000)
// 				}
				Dialog.confirm({
				  title: '提示',
				  message: '确定要转化为商机吗？'
				}).then(async() => {
				  let resp = await threadService.translate(clue.uuid);
				  if (resp.data.Status === "1") {
				     Toast.success('转化成功');
					 }
				}).catch(() => {
				  // on cancel
				});
				

// 				this.$router.push({path:"Transfer",query:{clue:clue}})
			},
		    onClickLeft() {
				if(this.$route.query.uuid) {
					window.open('/colseWebView');
				}else {
					this.$router.go(-1);
				}
		    },
		}
	}
</script>

<style>
	.van-popup--right {
	    width: 100%;
	    height: 100%;
	}
.form-box {
        margin-top: 120px;
    }
</style>
